import { Check } from '../icons';

/**
 * The empty-square checkbox used by DUE TODAY rows and the NEXT UP card
 * (today-view.md SS1.3/1.4). Real checkbox semantics (role="checkbox",
 * aria-checked); Enter/Space toggles. ~22-23px visible glyph, but the tap
 * target is padded out to touch.targetMin (44pt) via the button's own
 * padding rather than a separate hit-slop wrapper.
 */
export function CheckControl({
  checked,
  onToggle,
  label,
}: {
  readonly checked: boolean;
  readonly onToggle: () => void;
  readonly label: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      onClick={onToggle}
      style={{
        width: 'var(--touch-target-min)',
        height: 'var(--touch-target-min)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        marginTop: '-11px',
        marginLeft: '-11px',
        marginBottom: '-11px',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: '22px',
          height: '22px',
          borderRadius: 'var(--radius-sm)',
          border: checked ? 'none' : '1.5px solid var(--border-strong)',
          background: checked ? 'var(--hue-primary-vivid)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition:
            'background var(--dur-tap) var(--ease-standard), border-color var(--dur-tap) var(--ease-standard)',
        }}
      >
        {checked && (
          <Check size={14} strokeWidth={3} color="var(--text-on-accent)" />
        )}
      </span>
    </button>
  );
}
